export default __webpack_public_path__ + "static/media/image1.d31f4c63.png";